import jQuery from 'jquery';

export const siteHeader = () => {
    const siteHeaderMenuToggle = document.querySelector('.js-menu-toggle');
    const siteMenuHeader = document.querySelector('.header__menu');

    siteHeaderMenuToggle.addEventListener('click', () => {
        siteMenuHeader.classList.toggle('is-active');
        siteHeaderMenuToggle.classList.toggle('is-active');
    }, false);

    jQuery(() => {
        jQuery(window).scroll(() => {
            const scroll = jQuery(window).scrollTop();

            if (scroll >= 100) {
                jQuery('.header').addClass('header--fixed');
            } else {
                jQuery('.header').removeClass('header--fixed');
            }
        });
    });
};
